import { log } from 'console';
import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntil } from 'rxjs';
import { VIDEO_TUTORIAL } from '../../enum/video_tutorials.enum';
import { ClearObservableHelper } from '../../helpers/ClearObservableHelper';
import { UserData } from '../../interface/user';
import { DocumentsService } from '../../services/documents.service';
import { StorageService } from '../../services/storage.service';
@Component({
  selector: 'ngx-video-tutorials',
  templateUrl: './video-tutorials.component.html',
  styleUrls: ['./video-tutorials.component.scss'],
})
export class VideoTutorialsComponent extends ClearObservableHelper implements OnInit, OnDestroy {
  @ViewChild('videoTutorialDialog') videoTutorialDialog: TemplateRef<any>;
  tutorialData;
  isSmallIcon = false;
  isShowTutorial = true;
  user: UserData;
  showIcons = false;
  videoTutorials: any[] = [];
  isLoading = false;

  constructor(
    private matDialogService: MatDialog,
    public router: Router,
    private storageService: StorageService,
    private documentService: DocumentsService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.getIconValues();
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.getIconValues();
      }
    });

    this.storageService.hideTutorials.subscribe((x) => {
      this.isShowTutorial = x;
      this.storageService.setItem('isShowTutorial', x);
    });
  }

  getIconValues(): void {
    const user = this.storageService.getItem('user');
    this.isSmallIcon = user?.user?.isNewUser ? true : false;

    const storageItem = this.storageService.getItem('isShowTutorial');
    this.isShowTutorial = storageItem === false ? false : true;
  }

  // Method to open video on clicking icon
  openVideo(url: string) {
    this.tutorialData = { video: { url } };
    this.matDialogService.open(this.videoTutorialDialog, {
      width: this.tutorialData ? '60vw' : '40rem',
      height: this.tutorialData ? 'auto' : '25rem',
      panelClass: 'videoTutorialDialog',
    });
  }

  async openVideoTutorial() {
    try {
      this.isLoading = true; // Show loader when clicking the button
      const user = this.storageService.getItem('user');
      this.videoTutorials = [];
      let tutorialArray = [];
      this.tutorialData = null;

      if (this.router.url.includes('/test-quizzes/classroom-details')) {
        const tutorialDatabase = await this.documentService.getTutorialById(VIDEO_TUTORIAL.TEACHER_DASHBOARD);
        this.tutorialData = tutorialDatabase;
        if (
          this.storageService.checkUserRole(user.user.role_id, 'teacher') ||
          this.storageService.checkUserRole(user.user.role_id, 'teacher_only')
        ) {
          const tutorialDatabas = await this.documentService.getTutorialById(VIDEO_TUTORIAL.LESSON_PLAN);
          this.tutorialData = tutorialDatabas;
          tutorialArray.push(tutorialDatabase);
          tutorialArray.push(tutorialDatabas);
          this.showIcons = true;
        }
      } else if (this.router.url.includes('/dashboard/admin-dashboard')) {
        const tutorialDatabase = await this.documentService.getTutorialById(VIDEO_TUTORIAL.ADMIN_DASHBOARD);
        this.tutorialData = tutorialDatabase;
      } else if (this.router.url.includes('/test-quizzes/custom-classroom')) {
        const tutorialDatabase = await this.documentService.getTutorialById(VIDEO_TUTORIAL.EDIT_PACING_PLAN);
        this.tutorialData = tutorialDatabase;
      } else if (this.router.url === '/test-quizzes') {
        if (
          this.storageService.checkUserRole(user.user.role_id, 'teacher') ||
          this.storageService.checkUserRole(user.user.role_id, 'teacher_only')
        ) {
          const tutorialDatabase12 = await this.documentService.getTutorialById(VIDEO_TUTORIAL.AUTO_CLASSROOM);
          const tutorialDatabase13 = await this.documentService.getTutorialById(VIDEO_TUTORIAL.MANUAL_CLASSROOM);
          const tutorialDatabase14 = await this.documentService.getTutorialById(VIDEO_TUTORIAL.COPY_CLASSROOM);

          this.tutorialData = tutorialDatabase12;
          tutorialArray.push(tutorialDatabase12, tutorialDatabase13, tutorialDatabase14);
          this.showIcons = true;
        }
      } else if (this.router.url.includes('/pacing-lesson-plan')) {
        const tutorialDatabase = await this.documentService.getTutorialById(VIDEO_TUTORIAL.LESSON_PLAN_CREATION);
        this.tutorialData = tutorialDatabase;
      } else if (this.router.url.includes('/administration/school-instructional-peroids/teacher')) {
        const tutorialDatabase = await this.documentService.getTutorialById(VIDEO_TUTORIAL.SCHOOL_INSTRUCTIONAL_PERIOD);
        this.tutorialData = tutorialDatabase;
      } else {
        const cleanedUrl = this.router.url.replace(/\/\d+$/, '');
        const response = await this.documentService.getVideoTutorial({
          url: cleanedUrl,
        });
        tutorialArray = Object.values(response).filter((item) => typeof item === 'object');
        this.tutorialData = response[0];
      }

      // if (
      //   this.router.url === '/test-quizzes' ||
      //   (this.router.url.includes('/test-quizzes/classroom-details') &&
      //     (this.storageService.checkUserRole(user.user.role_id, 'teacher') ||
      //       this.storageService.checkUserRole(user.user.role_id, 'teacher_only')))
      // ) {
      //   tutorialArray.length > 0 ? (this.showIcons = true) : (this.showIcons = false);
      // } else {
      //   this.showIcons = false;
      // }

      if (tutorialArray?.length > 1 || this.tutorialData?.length > 1) {
        this.videoTutorials = tutorialArray
          .map((item: any) => ({
            url: item.video?.url,
            description: item.description,
          }))
          .filter((item) => item.url);
      } else {
        this.matDialogService.open(this.videoTutorialDialog, {
          width: this.tutorialData ? '60vw' : '40rem',
          height: this.tutorialData ? 'auto' : '25rem',
          panelClass: 'videoTutorialDialog',
        });
      }
    } catch (error) {
      console.log('openVideoTutorial', error);
      this.isLoading = false;
    } finally {
      this.isLoading = false;
    }
  }

  ngOnDestroy(): void {
    this.videoTutorials = [];
  }
}
